<nav
    class="navbar navbar-expand-nn fixed-top navbar-dark"
    role="navigation"
    [attr.aria-busy]="!navLoaded && !navError"
    [ngClass]="{ 'cmps-navbar-fixed-overflow': !isCollapsed }"
    (keydown)="_keyboardNavigator.handleEvent($event)"
    (keyup)="_keyboardNavigator.handleEvent($event)"
    (document:click)="_onDocumentClick()"
>
    <div
        class="navbar-collapse"
        id="navNavbar"
        [class.cmps-cdk-d-none]="isCollapsed"
    >
        <span class="navbar-brand d-flex align-items-center">
            <img
                class="cmps-nav-logo"
                src="assets/compas-logo-new.svg"
                alt
                role="presentation"
            />
        </span>
        <ul
            class="navbar-nav"
            role="menubar"
            aria-label="Navigation"
        >
            <!--TODO revise. handle errors better-->
            <li
                role="none"
                *ngIf="!nav || !nav.length || navError"
            >
                <span class="nav-link">{{
                    navError
                        ? i18n._676_COULDN_T_LOAD_NAVIGATION_
                        : (!nav || !nav.length) && navLoaded
                        ? i18n._677_NAVIGATION_IS_EMPTY_
                        : (i18n._675_LOADING_NAVIGATION_ | translate)
                }}</span>
            </li>
            <ng-template
                ngFor
                let-i
                let-ii="index"
                [ngForOf]="nav"
            >
                <ng-container
                    *ngTemplateOutlet="
                        i.hasChildren && !i.isNested
                            ? dropdown
                            : i.isNested
                            ? card
                            : single;
                        context: {
                            item: i,
                            index: ii,
                            tabIndex: ii === 0 ? 0 : -1
                        }
                    "
                ></ng-container>
            </ng-template>
        </ul>
    </div>
    <div class="d-flex">
        <button
            type="button"
            class="navbar-toggler d-nn-none"
            [attr.aria-label]="'Toggle navigation' | translate"
            aria-haspopup="true"
            aria-controls="navNavbar"
            [attr.aria-expanded]="!isCollapsed"
            (click)="onToggleNavigationClick($event)"
        >
            <span class="navbar-toggler-icon"></span>
        </button>
        <div
            class="navbar-nav flex-row ml-auto"
            role="menubar"
            aria-label="Account"
        >
            <cmps-event-centre-nav-button></cmps-event-centre-nav-button>
            <cmps-teamscall-task-list-nav-button></cmps-teamscall-task-list-nav-button>
            <cmps-teamscall-chat-menu-nav-button></cmps-teamscall-chat-menu-nav-button>
            <div
                class="nav-item cmps-nav-profile cmps-cdk-pos-relative"
                [class.active]="_profileChildIsActive()"
                [id]="'navbarDropdownProfile'"
                [attr.id]="'navbarDropdownProfile'"
                *ngIf="user"
            >
                <a
                    class="nav-link"
                    href
                    tabindex="-1"
                    role="menuitem"
                    aria-haspopup="true"
                    (click)="_onItemClick($event, -999)"
                >
                    <div
                        class="cmps-nav-icon"
                        aria-hidden="true"
                    >
                        <img
                            [src]="photoUrl"
                            alt
                            *ngIf="hasPhotoUrl"
                        />
                        <cmps-icon
                            svgIcon="account-circle"
                            *ngIf="!hasPhotoUrl"
                        ></cmps-icon>
                    </div>
                    <div
                        class="cmps-cdk-pt-0dot5 cmps-cdk-pl-0dot25 cmps-cdk-d-flex cmps-cdk-align-items-center"
                    >
                        <div>
                            <span
                                class="cmps-cdk-d-none cmps-cdk-d-lg-block cmps-cdk-px-0dot5"
                                [attr.aria-label]="
                                    i18n._678_LOGGED_IN_AS__NAME_
                                        | translate
                                            : {
                                                  name:
                                                      user.firstName +
                                                      ' ' +
                                                      user.lastName
                                              }
                                "
                                >{{ user.firstName }} {{ user.lastName }}</span
                            >
                            <div class="line"></div>
                        </div>
                        <div>
                            <cmps-icon svgIcon="menu-down"></cmps-icon>
                            <div class="cmps-cdk-h-4px"></div>
                        </div>
                    </div>
                </a>
                <div
                    class="cmps-cdk-bg-color-white cmps-cdk-border-color-grey-300 cmps-cdk-border-solid cmps-cdk-border-width-1p cmps-cdk-pos-absolute cmps-cdk-py-0dot5 cmps-cdk-pos-right-0 cmps-cdk-min-w-128px"
                    role="menu"
                    *ngIf="_navOpen[-999]"
                >
                    <span
                        class="dropdown-item disabled cmps-cdk-d-lg-none"
                        [attr.aria-label]="
                            i18n._678_LOGGED_IN_AS__NAME_
                                | translate
                                    : {
                                          name:
                                              user.firstName +
                                              ' ' +
                                              user.lastName
                                      }
                        "
                        >{{ user.firstName }} {{ user.lastName }}</span
                    >
                    <div
                        class="dropdown-divider cmps-cdk-d-lg-none"
                        role="separator"
                    ></div>
                    <a
                        class="dropdown-item"
                        tabindex="-1"
                        role="menuitem"
                        routerLink="/profile"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{
                            paths: 'exact',
                            queryParams: 'exact',
                            fragment: 'ignored',
                            matrixParams: 'ignored'
                        }"
                    >
                        {{ i18n._679_MY_PROFILE | translate }}
                    </a>
                    <a
                        class="dropdown-item"
                        tabindex="-1"
                        role="menuitem"
                        routerLink="/local-call/recognition/voice-profile"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{
                            paths: 'exact',
                            queryParams: 'exact',
                            fragment: 'ignored',
                            matrixParams: 'ignored'
                        }"
                    >
                        Voice Profile
                    </a>
                    <a
                        class="dropdown-item"
                        role="menuitem"
                        routerLink="/logout"
                        >{{ i18n._108_LOGOUT | translate }}</a
                    >
                </div>
            </div>
        </div>
    </div>
</nav>

<ng-template
    #single
    let-item="item"
    let-tabIndex="tabIndex"
>
    <li
        class="nav-item"
        role="none"
    >
        <cmps-nav-link
            className="nav-link"
            [tabIndex]="tabIndex"
            roleName="menuitem"
            [navItem]="item"
        >
            <ng-template
                cmpsNavLinkContent
                let-navItem="navItem"
            >
                <div class="cmps-cdk-pt-0dot5">
                    <span class="cmps-cdk-px-0dot5">{{
                        navItem.defaultName
                    }}</span>
                    <div class="line"></div>
                </div>
            </ng-template>
        </cmps-nav-link>
    </li>
</ng-template>
<ng-template
    #dropdown
    let-item="item"
    let-index="index"
    let-tabIndex="tabIndex"
>
    <li
        class="nav-item"
        [class.active]="_childIsActive(item)"
        role="none"
        [id]="'navbarDropdown' + index"
        [attr.id]="'navbarDropdown' + index"
    >
        <a
            class="nav-link"
            href
            [tabindex]="tabIndex"
            role="menuitem"
            aria-haspopup="true"
            (click)="_onItemClick($event, index)"
        >
            <div
                class="cmps-cdk-pt-0dot5 cmps-cdk-d-flex cmps-cdk-align-items-center"
            >
                <div>
                    <span class="cmps-cdk-px-0dot5">{{
                        item.defaultName
                    }}</span>
                    <div class="line"></div>
                </div>
                <div>
                    <cmps-icon svgIcon="menu-down"></cmps-icon>
                    <div class="cmps-cdk-h-4px"></div>
                </div>
            </div>
        </a>
        <div
            class="cmps-cdk-bg-color-white cmps-cdk-border-color-grey-300 cmps-cdk-border-solid cmps-cdk-border-width-1p cmps-cdk-pos-absolute cmps-cdk-py-0dot5 cmps-cdk-min-w-128px"
            role="menu"
            *ngIf="_navOpen[index]"
        >
            <ng-container *ngFor="let i of item.children">
                <cmps-nav-link
                    className="dropdown-item"
                    roleName="menuitem"
                    [activeOptions]="{
                        paths: 'exact',
                        queryParams: 'exact',
                        fragment: 'ignored',
                        matrixParams: 'ignored'
                    }"
                    [navItem]="i"
                >
                    <ng-template
                        cmpsNavLinkContent
                        let-navItem="navItem"
                    >
                        {{ navItem.defaultName }}
                    </ng-template>
                </cmps-nav-link>
            </ng-container>
        </div>
    </li>
</ng-template>
<ng-template
    #card
    let-item="item"
    let-index="index"
    let-tabIndex="tabIndex"
>
    <li
        class="nav-item"
        [class.active]="_childIsActive(item)"
        role="none"
        [id]="'navbarDropdown' + index"
        [attr.id]="'navbarDropdown' + index"
    >
        <a
            class="nav-link"
            href
            [tabindex]="tabIndex"
            role="menuitem"
            aria-haspopup="true"
            (click)="_onItemClick($event, index)"
        >
            <div
                class="cmps-cdk-pt-0dot5 cmps-cdk-d-flex cmps-cdk-align-items-center"
            >
                <div>
                    <span class="cmps-cdk-px-0dot5">{{
                        item.defaultName
                    }}</span>
                    <div class="line"></div>
                </div>
                <div>
                    <cmps-icon svgIcon="menu-down"></cmps-icon>
                    <div class="cmps-cdk-h-4px"></div>
                </div>
            </div>
        </a>
        <div
            class="cmps-cdk-bg-color-white cmps-cdk-border-color-grey-300 cmps-cdk-border-solid cmps-cdk-border-width-1p cmps-cdk-pos-absolute cmps-cdk-py-0dot5 cmps-cdk-pos-left-0 cmps-cdk-pos-right-0 cmps-cdk-min-w-128px"
            role="menu"
            *ngIf="_navOpen[index]"
        >
            <div class="cmps-cdk-d-flex cmps-cdk-flex-wrap">
                <ng-container *ngFor="let i of item.children">
                    <div *ngIf="i.children.length">
                        <span
                            class="dropdown-item cmps-cdk-font-size-15p cmps-cdk-font-bold"
                            >{{ i.defaultName }}</span
                        >
                        <ng-container *ngFor="let j of i.children">
                            <cmps-nav-link
                                className="dropdown-item"
                                roleName="menuitem"
                                [activeOptions]="{
                                    paths: 'exact',
                                    queryParams: 'exact',
                                    fragment: 'ignored',
                                    matrixParams: 'ignored'
                                }"
                                [navItem]="j"
                            >
                                <ng-template
                                    cmpsNavLinkContent
                                    let-navItem="navItem"
                                >
                                    {{ navItem.defaultName }}
                                </ng-template>
                            </cmps-nav-link>
                        </ng-container>
                    </div>
                </ng-container>
            </div>
        </div>
    </li>
</ng-template>
